import React, { useState } from 'react';
import Sidebar from 'components/Sidebar';
import MobileHeader from 'components/MobileHeader';
import SearchOverlay from 'components/SearchOverlay';
import Container from 'components/Container';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Link, useNavigate } from 'react-router-dom';
import { createFolder } from 'api/folders';
import TextInput from 'components/Form/TextInput';
import Button from 'components/Button';

export default function Create() {

    const [sidebar, setSidebar] = useState(false);
    const [search, setSearch] = useState(false);
    const cache = useQueryClient();
    const navigate = useNavigate();

    const { mutate: create } = useMutation({
        mutationKey: ['createFolder'],
        mutationFn: createFolder,
        onSuccess: (data) => {
            console.log("Folder created successfully:", data);
            cache.invalidateQueries(['folders']);

            return navigate(`/settings/folders/${data._id}`);
        },
        onError: (error) => {
            console.error("Error creating Folder:", error);
        }
    });

    function onSubmitHandler(formData) {
        const data = Object.fromEntries(formData);
        create({data});
    }


    return (
        <>
            <Sidebar
                visible={sidebar}
                setVisible={setSidebar}
            />

            <SearchOverlay
                visible={search}
                setVisible={setSearch}
            />

            <MobileHeader
                sidebar={sidebar}
                setSidebar={setSidebar}
                search={search}
                setSearch={setSearch}
            />

            <div className={`fixed top-0 w-full bottom-0 transition-all duration-300 ease-in-out lg:pl-[320px] ${sidebar ? 'left-[80vw]' : 'left-0'}`}>
                <Container className='!min-w-[700px] !max-w-[700px]'>
                    <div className='pb-8 pt-20 md:pt-14 text-center'>
                        <p className='text-3xl'>Crea nuova cartella</p>
                    </div>

                    <div className=''>
                        <form action={onSubmitHandler} className='flex flex-col gap-6'>
                            <TextInput
                                label="Nome"
                                name="name"
                                placeholder="Nome"
                            />
                            <TextInput
                                label="Descrizione"
                                name="description"
                                placeholder="Descrizione"
                            />

                            <div className='flex justify-between'>
                                <Link to="/settings/offices" className='hover:bg-verylight text-sm font-medium px-6 py-3 rounded-md transition-colors cursor-pointer duration-200'>Annulla</Link>
                                <Button submit>Salva</Button>
                            </div>
                        </form>
                    </div>

                </Container>
            </div>
        </>
    )
}
